import $ from 'jquery';
import { __ } from '@wordpress/i18n';
import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../sass/style.scss';

const initFaqStatic = () => {
    const faqBlocks = document.querySelectorAll('.ls-faq');

    faqBlocks.forEach( ( block ) => {
        const items = block.querySelectorAll('.ls-faq__item');

        items.forEach( ( item ) => {
            let trigger = item.querySelector('.ls-faq__trigger');
            const panel = item.querySelector('.ls-faq__panel');

            if ( ! trigger || ! panel ) {
                return;
            }

            if ( trigger.tagName === 'BUTTON' ) {
                const staticTrigger = document.createElement('span');
                staticTrigger.className = trigger.className;
                staticTrigger.innerHTML = trigger.innerHTML;
                trigger.replaceWith(staticTrigger);
                trigger = staticTrigger;
            }

            panel.classList.add('is-open');
            panel.removeAttribute('hidden');

            const panelInner = panel.querySelector('.ls-faq__panel-inner');
            const isEmpty = panelInner && panelInner.textContent.trim() === '' && ! panelInner.querySelector('img, iframe, video, audio, svg');

            if ( isEmpty ) {
                panel.hidden = true;
            }
        } );
    } );
};

const initPrimaryMenu = () => {
    const menus = document.querySelectorAll('.ls-primary-menu');

    menus.forEach( ( menu, index ) => {
        if ( menu.dataset.lsPrimaryInit === 'true' ) {
            return;
        }

        const toggle = menu.querySelector('.ls-primary-menu__toggle');
        const nav = menu.querySelector('.ls-primary-menu__nav');

        if ( ! toggle || ! nav ) {
            return;
        }

        menu.dataset.lsPrimaryInit = 'true';

        const navId = nav.id || menu.dataset.menuId || `ls-primary-menu-${ index }`;

        nav.id = navId;
        toggle.setAttribute('aria-controls', navId);

        const rawBreakpoint = parseInt( menu.dataset.breakpoint || '780', 10 );
        const breakpoint = Number.isFinite( rawBreakpoint ) ? rawBreakpoint : 780;
        const mediaQuery = window.matchMedia( `(max-width: ${ breakpoint }px)` );
        const submenuItems = Array.from( nav.querySelectorAll( '.menu-item-has-children' ) );

        let isExpanded = null;
        const submenuCloseTimers = new WeakMap();

        const getDirectSubmenu = ( item ) => Array.from( item.children ).find( ( child ) => child.classList?.contains( 'sub-menu' ) );
        const getDirectLink = ( item ) => Array.from( item.children ).find( ( child ) => child.tagName === 'A' );

        const cancelSubmenuClose = ( item ) => {
            const timer = submenuCloseTimers.get( item );

            if ( timer ) {
                window.clearTimeout( timer );
                submenuCloseTimers.delete( item );
            }
        };

        const closeSubmenu = ( item ) => {
            const submenu = getDirectSubmenu( item );
            const submenuToggle = item.querySelector( ':scope > .ls-primary-menu__submenu-toggle' );

            cancelSubmenuClose( item );
            item.classList.remove( 'is-submenu-open' );

            if ( submenu ) {
                submenu.setAttribute( 'hidden', '' );
            }

            if ( submenuToggle ) {
                submenuToggle.setAttribute( 'aria-expanded', 'false' );
            }
        };

        const openSubmenu = ( item ) => {
            const submenu = getDirectSubmenu( item );
            const submenuToggle = item.querySelector( ':scope > .ls-primary-menu__submenu-toggle' );

            if ( ! submenu ) {
                return;
            }

            cancelSubmenuClose( item );

            submenuItems.forEach( ( sibling ) => {
                if ( sibling !== item && ! item.contains( sibling ) ) {
                    closeSubmenu( sibling );
                }
            } );

            item.classList.add( 'is-submenu-open' );
            submenu.removeAttribute( 'hidden' );

            if ( submenuToggle ) {
                submenuToggle.setAttribute( 'aria-expanded', 'true' );
            }
        };

        const closeSubmenus = () => {
            submenuItems.forEach( closeSubmenu );
        };

        const scheduleSubmenuClose = ( item ) => {
            cancelSubmenuClose( item );

            const timer = window.setTimeout( () => {
                closeSubmenu( item );
            }, 180 );

            submenuCloseTimers.set( item, timer );
        };

        submenuItems.forEach( ( item, itemIndex ) => {
            const submenu = getDirectSubmenu( item );
            const parentLink = getDirectLink( item );

            if ( ! submenu || ! parentLink ) {
                return;
            }

            const submenuId = submenu.id || `${ navId }-submenu-${ itemIndex }`;
            let submenuToggle = item.querySelector( ':scope > .ls-primary-menu__submenu-toggle' );

            submenu.id = submenuId;
            submenu.setAttribute( 'hidden', '' );
            parentLink.setAttribute( 'aria-haspopup', 'true' );

            if ( ! submenuToggle ) {
                submenuToggle = document.createElement( 'button' );
                submenuToggle.className = 'ls-primary-menu__submenu-toggle';
                submenuToggle.type = 'button';
                submenuToggle.innerHTML = '<span class="ls-primary-menu__submenu-icon" aria-hidden="true"></span>';
                parentLink.insertAdjacentElement( 'afterend', submenuToggle );
            }

            submenuToggle.setAttribute( 'aria-controls', submenuId );
            submenuToggle.setAttribute( 'aria-expanded', 'false' );
            submenuToggle.setAttribute(
                'aria-label',
                `${ __( 'Rozwiń submenu', 'wp-kio' ) }: ${ parentLink.textContent.trim() }`
            );

            submenuToggle.addEventListener( 'click', ( event ) => {
                event.preventDefault();
                event.stopPropagation();

                if ( item.classList.contains( 'is-submenu-open' ) ) {
                    closeSubmenu( item );
                } else {
                    openSubmenu( item );
                }
            } );

            item.addEventListener( 'mouseenter', () => {
                if ( ! mediaQuery.matches ) {
                    openSubmenu( item );
                }
            } );

            item.addEventListener( 'mouseleave', () => {
                if ( ! mediaQuery.matches ) {
                    scheduleSubmenuClose( item );
                }
            } );

            item.addEventListener( 'focusin', () => {
                if ( ! mediaQuery.matches ) {
                    openSubmenu( item );
                }
            } );

            item.addEventListener( 'focusout', ( event ) => {
                if ( ! mediaQuery.matches && ! item.contains( event.relatedTarget ) ) {
                    closeSubmenu( item );
                }
            } );
        } );

        const setState = ( expand ) => {
            if ( expand === isExpanded ) {
                return;
            }

            isExpanded = expand;

            toggle.setAttribute('aria-expanded', expand ? 'true' : 'false' );
            menu.dataset.lsPrimaryExpanded = expand ? 'true' : 'false';
            menu.classList.toggle('is-open', expand );

            if ( expand ) {
                nav.classList.add( 'is-open' );
                nav.removeAttribute( 'hidden' );
            } else {
                nav.classList.remove( 'is-open' );
                nav.setAttribute( 'hidden', '' );
                closeSubmenus();
            }
        };

        const syncWithViewport = ( matchesMobile ) => {
            closeSubmenus();
            setState( ! matchesMobile );
        };

        syncWithViewport( mediaQuery.matches );

        const handleMediaChange = ( event ) => {
            syncWithViewport( event.matches );
        };

        if ( typeof mediaQuery.addEventListener === 'function' ) {
            mediaQuery.addEventListener( 'change', handleMediaChange );
        } else if ( typeof mediaQuery.addListener === 'function' ) {
            mediaQuery.addListener( handleMediaChange );
        }

        toggle.addEventListener( 'click', () => {
            const currentlyExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
            setState( ! currentlyExpanded );
        } );

        nav.addEventListener( 'keyup', ( event ) => {
            if ( event.key === 'Escape' || event.key === 'Esc' ) {
                closeSubmenus();

                if ( mediaQuery.matches ) {
                    setState( false );
                    toggle.focus();
                }
            }
        } );

        nav.querySelectorAll( 'a' ).forEach( ( link ) => {
            link.addEventListener( 'click', () => {
                if ( mediaQuery.matches ) {
                    setState( false );
                }
            } );
        } );

        const handleDocumentClick = ( event ) => {
            if ( ! mediaQuery.matches ) {
                return;
            }

            if ( ! menu.contains( event.target ) ) {
                closeSubmenus();
                setState( false );
            }
        };

        document.addEventListener( 'click', handleDocumentClick );
    } );
};

const initMegaMenu = () => {
    const menus = document.querySelectorAll('.ls-menu-special');

    menus.forEach( ( menu ) => {
        if ( menu.dataset.lsMegaInit === 'true' ) {
            return;
        }

        menu.dataset.lsMegaInit = 'true';

        const closeItem = ( item ) => {
            const trigger = item.querySelector('.ls-menu-special__link');
            const panel = item.querySelector('.ls-menu-special__mega, .ls-menu-special__list-content');

            if ( trigger ) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            if ( panel ) {
                panel.setAttribute('hidden', '');
            }

            item.classList.remove('is-open');
        };

        const items = menu.querySelectorAll('.ls-menu-special__item.is-mega, .ls-menu-special__item.has-list');

        items.forEach( ( item, index ) => {
            const trigger = item.querySelector('.ls-menu-special__link');
            const panel = item.querySelector('.ls-menu-special__mega, .ls-menu-special__list-content');

            if ( ! trigger || ! panel ) {
                return;
            }

            let closeTimeout;

            const panelId = panel.id || `ls-mega-panel-${ index }-${ Math.random().toString(36).slice(2, 8) }`;

            panel.id = panelId;
            panel.setAttribute('hidden', '');
            trigger.setAttribute('aria-controls', panelId);
            trigger.setAttribute('aria-haspopup', 'true');
            trigger.setAttribute('aria-expanded', 'false');

            const cancelClose = () => {
                if ( closeTimeout ) {
                    window.clearTimeout( closeTimeout );
                }
            };

            const open = () => {
                menu.querySelectorAll('.ls-menu-special__item.is-open').forEach( ( openItem ) => {
                    if ( openItem !== item ) {
                        closeItem( openItem );
                    }
                } );

                cancelClose();
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
                panel.removeAttribute('hidden');
            };

            const close = () => {
                cancelClose();
                closeTimeout = window.setTimeout( () => {
                    closeItem( item );
                }, 120 );
            };

            item.addEventListener('mouseenter', open );
            item.addEventListener('mouseleave', close );

            trigger.addEventListener('focus', open );
            trigger.addEventListener('blur', ( event ) => {
                if ( ! item.contains( event.relatedTarget ) ) {
                    close();
                }
            } );

            panel.addEventListener('focusin', open );
            panel.addEventListener('focusout', ( event ) => {
                if ( ! panel.contains( event.relatedTarget ) ) {
                    close();
                }
            } );

            closeItem( item );
        } );
    } );
};

const initSliders = () => {
    const jQueryRef = window?.jQuery || $;

    if ( ! jQueryRef || ! jQueryRef.fn || typeof jQueryRef.fn.owlCarousel !== 'function' ) {
        return;
    }

    const navText = [
        `<span class="ls-slider__nav-icon" aria-hidden="true">‹</span><span class="screen-reader-text">${ __( 'Previous slide', 'wp-kio' ) }</span>`,
        `<span class="ls-slider__nav-icon" aria-hidden="true">›</span><span class="screen-reader-text">${ __( 'Next slide', 'wp-kio' ) }</span>`,
    ];

    const baseOptions = {
        items: 1,
        loop: true,
        margin: 24,
        nav: true,
        dots: true,
        navText,
        smartSpeed: 450,
    };

    const ensureCarousel = ( element, overrides = {} ) => {
        if ( ! element || element.dataset.lsSliderInit === 'true' ) {
            return;
        }

        const $element = jQueryRef( element );

        if ( ! $element.length ) {
            return;
        }

        const options = { ...baseOptions, ...overrides };

        element.dataset.lsSliderInit = 'true';
        $element.addClass( 'owl-carousel' );
        $element.owlCarousel( options );
    };

    document.querySelectorAll( '.ls-slider__track' ).forEach( ( track ) => {
        ensureCarousel( track );
    } );

    document.querySelectorAll( '.ls-slider-dynamic__track' ).forEach( ( track ) => {
        ensureCarousel( track, {
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true,
        } );
    } );

    document.querySelectorAll( '.kio-partners__track' ).forEach( ( track ) => {
        ensureCarousel( track, {
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 4500,
            dots: true,
            loop: true,
            margin: 24,
            nav: true,
            responsive: {
                0: {
                    items: 2,
                },
                700: {
                    items: 3,
                },
                1024: {
                    items: 5,
                },
            },
        } );
    } );
};

const activateTab = ( tab, tabs, panels ) => {
    const controls = tab.getAttribute('aria-controls');
    const panel = controls ? document.getElementById(controls) : null;

    tabs.forEach( ( currentTab ) => {
        currentTab.classList.remove('is-active');
        currentTab.setAttribute('aria-selected', 'false');
        currentTab.setAttribute('tabindex', '-1');
    } );

    panels.forEach( ( currentPanel ) => {
        currentPanel.classList.remove('is-active');
        currentPanel.setAttribute('hidden', '');
    } );

    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    if ( panel ) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
    }
};

const handleTabKeyboardNavigation = ( event, tabs ) => {
    const currentIndex = tabs.indexOf(event.currentTarget);

    if ( currentIndex === -1 ) {
        return;
    }

    const focusTab = ( index ) => {
        const tabToFocus = tabs[index];

        if ( tabToFocus ) {
            tabToFocus.focus();
        }
    };

    switch ( event.key ) {
        case 'ArrowRight':
        case 'ArrowDown':
            event.preventDefault();
            focusTab( ( currentIndex + 1 ) % tabs.length );
            break;
        case 'ArrowLeft':
        case 'ArrowUp':
            event.preventDefault();
            focusTab( ( currentIndex - 1 + tabs.length ) % tabs.length );
            break;
        default:
            break;
    }
};

const initTabs = () => {
    const tabContainers = document.querySelectorAll('.ls-tabs');

    tabContainers.forEach( ( container ) => {
        const tabs = Array.from( container.querySelectorAll('.ls-tabs__nav-item') );
        const panels = Array.from( container.querySelectorAll('.ls-tabs__panel') );

        if ( ! tabs.length || ! panels.length ) {
            return;
        }

        tabs.forEach( ( tab ) => {
            tab.addEventListener('click', ( event ) => {
                event.preventDefault();
                activateTab( tab, tabs, panels );
            } );

            tab.addEventListener('keydown', ( event ) => handleTabKeyboardNavigation( event, tabs ) );
        } );

        const initialTab = tabs.find( ( candidate ) => candidate.classList.contains('is-active') ) || tabs[0];

        if ( initialTab ) {
            activateTab( initialTab, tabs, panels );
        }
    } );
};

const initCounters = () => {
    const counters = document.querySelectorAll('[data-kio-counter]');

    if ( ! counters.length ) {
        return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const formatValue = ( value ) => Number.isInteger( value ) ? String( value ) : value.toLocaleString( 'pl-PL' );

    const setFinalValue = ( counter ) => {
        const target = Number.parseFloat( counter.dataset.kioCounterValue || '0' );
        const suffix = counter.dataset.kioCounterSuffix || '';

        counter.textContent = `${ formatValue( target ) }${ suffix }`;
    };

    const animateCounter = ( counter ) => {
        if ( counter.dataset.kioCounterDone === 'true' ) {
            return;
        }

        counter.dataset.kioCounterDone = 'true';

        const target = Number.parseFloat( counter.dataset.kioCounterValue || '0' );
        const suffix = counter.dataset.kioCounterSuffix || '';

        if ( ! Number.isFinite( target ) || prefersReducedMotion ) {
            setFinalValue( counter );
            return;
        }

        const duration = 1100;
        const startTime = window.performance.now();

        const tick = ( now ) => {
            const progress = Math.min( ( now - startTime ) / duration, 1 );
            const eased = 1 - Math.pow( 1 - progress, 3 );
            const current = Math.round( target * eased );

            counter.textContent = `${ formatValue( current ) }${ suffix }`;

            if ( progress < 1 ) {
                window.requestAnimationFrame( tick );
            } else {
                setFinalValue( counter );
            }
        };

        counter.textContent = `0${ suffix }`;
        window.requestAnimationFrame( tick );
    };

    if ( typeof window.IntersectionObserver !== 'function' ) {
        counters.forEach( animateCounter );
        return;
    }

    const observer = new window.IntersectionObserver( ( entries ) => {
        entries.forEach( ( entry ) => {
            if ( ! entry.isIntersecting ) {
                return;
            }

            animateCounter( entry.target );
            observer.unobserve( entry.target );
        } );
    }, { threshold: 0.35 } );

    counters.forEach( ( counter ) => observer.observe( counter ) );
};

const initContactEmailReveal = () => {
    document.querySelectorAll('.kio-contact-section__email-reveal[data-email]').forEach( ( button ) => {
        if ( button.dataset.kioEmailRevealInit === 'true' ) {
            return;
        }

        button.dataset.kioEmailRevealInit = 'true';

        button.addEventListener('click', () => {
            const email = button.dataset.email;

            if ( ! email ) {
                return;
            }

            const link = document.createElement('a');
            link.className = 'kio-contact-section__value';
            link.href = `mailto:${ email }`;
            link.textContent = email;
            button.replaceWith( link );
        } );
    } );
};

const initTrainingFormTitle = () => {
    document.querySelectorAll('.kio-cf7-form--training').forEach( ( wrapper ) => {
        const field = wrapper.querySelector('input[name="szkolenie"]');

        if ( ! field ) {
            return;
        }

        const title = wrapper.dataset.trainingTitle || document.querySelector('.wp-block-post-title, h1')?.textContent?.trim() || document.title.replace(/\s+[-|].*$/, '').trim();

        if ( title ) {
            field.value = title;
        }
    } );
};

document.addEventListener('DOMContentLoaded', () => {
    initPrimaryMenu();
    initMegaMenu();
    initFaqStatic();
    initTabs();
    initSliders();
    initCounters();
    initContactEmailReveal();
    initTrainingFormTitle();
} );

window.addEventListener('load', () => {
    initSliders();
});

console.info('[wp-webpack-theme is live]');
